import { Message } from '@liscio/api';

const ERROR_STATE = {
  messages: [],
};

export const extractValues: (
  data: any,
  activeTab: string,
  error?: any
) => {
  messages: Array<Message>;
} = (data, activeTab, error) => {
  const hasError = Boolean(error);

  if (hasError) {
    return ERROR_STATE;
  }

  const messages = data?.pages
    .map((page: any) => {
      return page?.[activeTab] || [];
    })
    .reduce((prev: any, current: any) => {
      return [...prev, ...current];
    }, []) as Array<Message>;

  return { messages };
};

export default extractValues;
